// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  ml, mt, pt, mb, py, px, pb, pr
} from 'styled-components-spacing';
import Grid from 'styled-components-grid';

import theme from '@theme';

export const StyledFooter = styled.div`
 
  background-color: ${props => (props.curefyDomain ? '#c1eedb' : theme.colors.darkBlue2)};
  color: ${theme.colors.brokenWhite};
  ${px(3.5)}
  ${py(4.5)}
  ${pb(6)}

  ${breakpoint('desktop')`
    position: absolute;
    z-index: 200;
    ${px(6)}
    ${pt(5.5)}
    ${pb(6)}
  `}
  @media (min-width: 1024px) and (max-width:1800px){
    width: auto;
  }
  @media (min-width: 1800px){
    width: 100%;
  }
`;

export const StyledGridUnit = styled(Grid.Unit)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledFooterLinks = styled.div`
  ${mt(4.5)}
  ${mb(4)}
  ${pt(2)}
  ${breakpoint('desktop')`
    ${mt(0)}
    ${pt(0)}
  `}
`;

export const StyledListTitle = styled.a`
  display: block;
  text-decoration: none;
  color:${props => (props.curefyDomain ? 'rgb(1,57,57)' : theme.colors.aquaMarine)};
  font-weight: bold;
  line-height: 1.44rem;
  ${({ noPointer }) => (noPointer ? null : 'cursor: pointer;')}
  ${pb(2)}

  ${breakpoint('desktop')`
    ${pb(4)}
    ${pt(2)}
  `}
`;

export const StyledList = styled.div`
  ${py(3.5)}
  ${pr(3)}

  ${breakpoint('desktop')`
    ${py(0)}
  `}
`;

export const StyledListItem = styled.div`
  ${pt(2.5)}
  ${pb(2)}

  ${breakpoint('desktop')`
    &:last-child {
      ${mb(3.5)}
    }
  `}
`;

export const StyledListLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  line-height: 1.44rem;
  transition: all 0.5s ease;
  color:${props => (props.curefyDomain ? 'rgb(1,57,57)' : theme.colors.white)};

  &:hover {
    color: ${props => (props.curefyDomain ? 'rgb(16 182 50)' : theme.colors.defaultGreen)};
  }
`;

export const StyledListLinkPrimary = styled(StyledListLink)`
  color: ${theme.colors.defaultGreen};
`;

export const StyledCopyrightInfo = styled.div`
  size: 16px;
  line-height: 24px;
  color:${props => (props.curefyDomain ? 'rgb(1,57,57)' : theme.colors.white)};

  ${mt(4)}

  ${breakpoint('desktop')`
    max-width: none;
  `}
`;

export const StyledGrid = styled(Grid)`
  border-top: 2px solid ${props => (props.curefyDomain ? 'rgb(1,57,57)' : theme.colors.white)};
  ${pt(4)}

  align-items: baseline;
  justify-content: space-between;

  ${breakpoint('desktop')`
    div:last-child {
      display: flex;
      justify-content: flex-end;
    }`}
`;

export const StyledEkomiSiegel = styled.div`
  height: 131px;
  ${ml(2)}
  ${mt(2)}
  ${breakpoint('desktop')`
    ${ml(4.5)}
  `}
`;

export const StyledAusgezeichnetSiegel = styled.div`
  width: 150px !important;
`;

export const StyledCertificates = styled.div`
  ${mt(4.5)}
  ${mb(3)}

  display: flex;
  flex-direction: flex-start;
  align-items: flex-start;

  ${breakpoint('desktop')`
    ${mt(3)}
    ${mb(4.5)}
  `}
`;
